import c from 'classnames';

import { Icon } from '@repo/ui';
import { ActivationStep, ActivationStepKey } from 'hooks/useActivationSteps';
import { ActivationStepper } from '../ActivationStepper/ActivationStepper';
import { ActivationBackButton } from './ActivationBackButton';

import styles from './ActivationHeader.module.css';

export type ActivationHeaderProps = {
  steps: ActivationStep[];
  currentStepKey: ActivationStepKey;
  onBack?: () => void;
  onClose?: () => void;
  stepperClassName?: string;
  allCompleted?: boolean;
};

/**
 * Shared back/stepper/close header for the ENG-4942 redesigned activation
 * flow. Used by both the Kits container (ActivationNavigation) and the
 * Information landing screen so the two route trees render identical chrome.
 */
export const ActivationHeader = ({
  steps,
  currentStepKey,
  onBack,
  onClose,
  stepperClassName,
  allCompleted,
}: ActivationHeaderProps) => {
  return (
    <>
      <div className={c(styles.header, !onClose && styles.headerNoClose)}>
        {onBack && (
          <ActivationBackButton onBack={onBack} className={styles.backButton} />
        )}
        <div className={c(styles.stepperWrapper, stepperClassName)}>
          <ActivationStepper
            steps={steps}
            currentStepKey={currentStepKey}
            allCompleted={allCompleted}
          />
        </div>
        {onClose && (
          <div className={styles.navClose}>
            <div
              className={styles.closeButton}
              onClick={onClose}
              aria-label='Close'
              data-testid='close-button'
            >
              <Icon name='closeSm' />
            </div>
          </div>
        )}
      </div>
    </>
  );
};
